import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { LanguageService } from '../../../core/services/language.service';
import { CardOptionListComponent } from '../../../osp-ui/components/form/card-option-list/card-option-list.component';
import { CardOptionType } from '../../../osp-ui/components/form/card-option-list/contracts/card-option-type.contract';
import { DialogComponent } from '../../../osp-ui/components/overlay/dialog/dialog/dialog.component';
import { OspTemplateDirective } from '../../../osp-ui/directives/osp-template.directive';
import { IconProviderService } from '../../../whitelabel/services/icon-provider.service';
import { AssetType } from '../../enums/asset-type.enum';
import { AccessService } from '../../services/access.service';

@Component({
  selector: 'osp-entity-create-dialog',
  standalone: true,
  imports: [DialogComponent, OspTemplateDirective, CardOptionListComponent, FormsModule, TranslateModule],
  templateUrl: './entity-create-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityCreateDialogComponent {
  private readonly accessService = inject(AccessService);
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly languageService = inject(LanguageService);
  private readonly iconProviderService = inject(IconProviderService);

  readonly assets: CardOptionType[] = [
    {
      type: AssetType.EQUIPMENT,
      icon: this.iconProviderService.getIcon(IconKey.EquipmentCreateMain),
      label: this.languageService.getInstant('general.equipm.s'),
      description: this.languageService.getInstant('shared.createEntity.entitySelection.equipment.description'),
      hidden: !this.accessService.canCreateEquipment(),
    },
  ];
  readonly $selectedType = signal<AssetType | null>(null);

  constructor() {
    effect(() => {
      if (this.$selectedType()) {
        this.dialogRef.close(this.$selectedType());
      }
    });
  }
}
